import axios from 'axios';
import { AUTH_TOKEN } from '../environments';
import {
  basicUrl,
  basicUrl2,
  buzzNotificationUrl,
  buzzOneUrl,
} from '../utils/enum';
import qs from 'qs';

export default axios.create({
  baseURL: buzzOneUrl,
  headers: {
    Authorization: AUTH_TOKEN,
    'Content-Type': 'application/json',
  },
});

export const axiosAtheneum = axios.create({
  baseURL: buzzOneUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const axiosWhitelabeled = axios.create({
  baseURL: buzzOneUrl,
  headers: {
    Authorization: AUTH_TOKEN,
    'Content-Type': 'application/json',
  },
});

export const axios8251 = axios.create({
  baseURL: basicUrl2,
  headers: {
    Authorization: AUTH_TOKEN,
    'Content-Type': 'application/json',
  },
});

export const unAuthGenericAxios = ({
  baseURL = basicUrl2,
  authToken = AUTH_TOKEN,
  contentType = 'application/json',
}) => {
  console.log({ baseURL, authToken, contentType });
  if (authToken) {
    return axios.create({
      baseURL,
      headers: {
        Authorization: authToken,
        'Content-Type': contentType,
      },
    });
  }
  return axios.create({
    baseURL,
    headers: {
      'Content-Type': contentType,
    },
  });
};

export const fileAxios = axios.create({
  baseURL: basicUrl,
  headers: {
    Authorization: AUTH_TOKEN,
    'Content-Type': 'multipart/form-data',
  },
});

export const fileAxios8251 = axios.create({
  baseURL: basicUrl2,
  headers: {
    Authorization: AUTH_TOKEN,
    'Content-Type': 'multipart/form-data',
  },
});

export const unAuthAxios = axios.create({
  baseURL: basicUrl,
});

export const axiosBuzzOne = axios.create({
  baseURL: buzzOneUrl,
  headers: {
    Authorization: AUTH_TOKEN,
    'Content-Type': 'application/json',
  },
  paramsSerializer: (params) =>
    qs.stringify(params, {
      arrayFormat: 'repeat',
      filter: (prefix, value) => {
        if (value === '' || value === null || value === undefined) {
          return; // Skip this key
        }
        return value;
      },
    }),
});

export const axiosBuzzNotification = axios.create({
  baseURL: buzzNotificationUrl,
  headers: {
    Authorization: AUTH_TOKEN,
    'Content-Type': 'application/json',
  },
});
